














import Vue from 'vue';

export default Vue.extend({
  name: 'Rating',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    showNumber: Boolean,
  },
  computed: {
    width(): number {
      const denominator10 = Math.round((this.value * 10) / 5);

      return denominator10 * 10;
    },
  },
});
